import React from 'react'

import { Col, Form } from '_zari/core'

const ImporteGravadoFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='GRAVADO' htmlFor='input-importeGravado' md={12} />
      <Col md={12}>
        <Form.InputNumber
          id='input-importeGravado'
          name='input-importeGravado'
          value={iValue}
          disabled
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteGravadoFormGroup)
